import { render, staticRenderFns } from "./LsportEuropeanCart.vue?vue&type=template&id=3b8f5f51&scoped=true"
import script from "./LsportEuropeanCart.vue?vue&type=script&lang=js"
export * from "./LsportEuropeanCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f5f51",
  null
  
)

export default component.exports